import {Remote10} from "./Remote10"
import {RemoteBase, RemoteEndpoint_Impl_, ResponseReader_Impl_} from "./Remote"
import {Single} from "../../streams/Stream"
import {Builder7} from "../../querystring/Builder7"
import {Parser12} from "../../json/Parser12"
import {HeaderField, HeaderValue_Impl_} from "../../http/Header"
import {LazyConst} from "../../core/Lazy"
import {ByteChunk} from "../../chunk/ByteChunk"
import {Bytes} from "../../../haxe/io/Bytes"
import {Register} from "../../../genes/Register"

export const Remote9 = Register.global("$hxClasses")["tink.web.proxy.Remote9"] = 
class Remote9 extends Register.inherits(RemoteBase) {
	new(client, endpoint) {
		super.new(client, endpoint);
	}
	get(options) {
		let __body__ = "";
		return RemoteEndpoint_Impl_.request(RemoteEndpoint_Impl_.sub(this.endpoint, {"path": [], "query": [], "headers": [new HeaderField("content-length", HeaderValue_Impl_.ofInt(ByteChunk.of(Bytes.ofString(__body__)).getLength())), new HeaderField("accept", "application/json")].concat(new Builder7().stringify({"_8": options.lang}))}), this.client, "GET", new Single(new LazyConst(ByteChunk.of(Bytes.ofString(__body__)))), ResponseReader_Impl_.ofStringReader((o=>Register.bind(o, o.tryParse))(new Parser12())));
	}
	feedbacks() {
		let this1 = "feedbacks";
		return new Remote10(this.client, RemoteEndpoint_Impl_.sub(this.endpoint, {"path": [this1], "query": [], "headers": [].concat([])}));
	}
	static get __name__() {
		return "tink.web.proxy.Remote9"
	}
	static get __super__() {
		return RemoteBase
	}
	get __class__() {
		return Remote9
	}
}

